import fossilImg1 from '@/assets/img/content4/category1/fossilImg1.jpg'
import fossil2Img1 from '@/assets/img/content4/category2/fossil2Img1.jpg'
import fossil2Img2 from '@/assets/img/content4/category2/fossil2Img2.jpg'
import fossil2Img3 from '@/assets/img/content4/category2/fossil2Img3.jpg'
import categoryInfo from '@/assets/img/content4/category1/categoryInfo.png'

export const reptilesShowList = [ // 爬行动物展示化石
  {
    id: 1,
    src: fossilImg1,
    title: '化石：悟空翼龙科',
    enTitle: 'Wukongopteridae',
    details: '这是一类介于“喙嘴龙类”和 “翼手龙类”之间的过渡翼龙类型，展现了诸如愈合的鼻眶腔孔、加长的颈椎、长尾、发达的第五趾等镶嵌特征。截至目前，悟空翼龙科共包括悟空翼龙、达尔文翼龙、鲲鹏翼龙以及可能的长城翼龙和建昌翼龙等五个属。',
  },
]

export const reptilesAnimal = {
  animalType: '爬行动物', // 动物类别
  animalTypeEn: 'Reptile', // 动物类别英文名字
  categoryInfoImg: categoryInfo, // 动物特点介绍图片
  categoryTxt: '根据最新爬行动物分类依据（Benton，2014），现存的爬行动物可分为副爬行动物亚纲（Parareptilia）和真爬行动物亚纲（Eureptilia）。而传统上根据头骨颞孔的有无，数目及其位置的不同，爬行动物可分为4个亚纲（Romer，1933）：无孔亚纲Anapsida（无颞孔）；双孔亚纲Diapsida（有两个颞孔）；调孔亚纲Euryapsida（一个颞孔位于眶后骨和鳞骨的上方）；下孔亚纲Synapsida（一个颞孔位于眶后骨和鳞骨下方）。', // 动物文字介绍
  showList: reptilesShowList,
}

export const JeholBiotaList = [
  {
    id: 1,
    src: fossil2Img1,
    title: '化石：鹦鹉嘴龙',
    enTitle: '<em>Psittacosaurus</em> sp.',
    details: '鹦鹉嘴龙属于鸟臀目的角龙类恐龙，是亚洲特有的恐龙，因为吻部长得像鹦鹉嘴而得名。不过和大多数四足行走的角龙不同，鹦鹉嘴龙是两足行走的植食性恐龙。',
  },
  {
    id: 2,
    src: fossil2Img2,
    title: '化石：伊克昭龙',
    enTitle: '<em>Ikechosaurus</em>',
    details: '',
  },
  {
    id: 3,
    src: fossil2Img3,
    title: '化石：古兽',
    enTitle: '',
    details: '',
  },
  
]

export const JeholBiotaAnimal = {
  animalType: '热河生物群', // 动物类别
  animalTypeEn: 'Jehol Biota', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '广义的热河生物群是一个繁盛于中生代晚期，分布于中国东北和华北、蒙古、西伯利亚、以及朝鲜和日本等东亚地区的陆生、湖泊相生物群。热河生物群的集群死亡与埋藏与火山喷发有关，因此形成了保存精美的化石，它也被誉为“中生代的化石庞贝城”。这些精美的化石在探索鸟类及其飞行包括羽毛的起源方面有着重要的科学价值。近20年来，热河生物群脊椎动物化石的研究取得了举世瞩目的重要进展，已发现并命名的种类至少有121属142种（周忠和，王原，2010）。', // 动物文字介绍
  showList: JeholBiotaList,
}

export const btnList = [
  {
    id: 1,
    cnTitle: '爬行动物',
    enTitle: 'Reptile',
  },
  {
    id: 2,
    cnTitle: '热河生物群',
    enTitle: 'Jehol Biota',
  },
]